import { useEffect, useRef } from "react";
import { Eraser } from "lucide-react";

export function SignaturePad({ onChange, testid = "signature-pad" }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio; c.height = 180 * ratio;
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.strokeStyle = "#0f172a";
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return [p.clientX - r.left, p.clientY - r.top];
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.lineTo(x, y); ctx.stroke(); dirty.current = true; };
  const end = () => { if (!drawing.current) return; drawing.current = false; if (dirty.current) onChange(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); dirty.current = false; onChange(""); };

  return (
    <div className="relative" data-testid={testid}>
      <canvas ref={ref} className="w-full h-[180px] rounded-xl border-2 border-dashed border-slate-300 bg-white touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <span className="pointer-events-none absolute left-4 bottom-3 text-[11px] text-slate-400">Sign here</span>
      <button type="button" onClick={clear} data-testid={`${testid}-clear`}
        className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-md bg-white/90 border border-slate-200 px-2 py-1 text-[11px] text-slate-600 hover:bg-slate-100">
        <Eraser className="h-3 w-3" /> Clear
      </button>
    </div>
  );
}
